<template>
    <div style="margin: 20px 0 30px">
        <el-table :data="data" size="small" class="ah-el-data-table no-bottom-border row-click" @row-click="$event => $emit('row-click', $event)">
            <el-table-column type="index"></el-table-column>
            <el-table-column label="類型" width="85">財務單</el-table-column>
            <el-table-column label="單號" prop="moo" width="140"></el-table-column>
            <el-table-column label="匯款戶名" prop="vdR_BNK_TPC" width="140"></el-table-column>
            <el-table-column label="摘要" prop="tpc"></el-table-column>
            <el-table-column label="金額" prop="amt" align="right">
                <template slot-scope="scope">
                    <Money :v="scope.row.amt" />
                </template>
            </el-table-column>
            <el-table-column label="幣別" prop="cny" width="80">
                <template slot-scope="scope">
                    <span>{{ scope.row.cny }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
